import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

function StopConfirmationDialog({ open, onConfirm, onCancel }) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Confirmar Encerramento</DialogTitle>
      <DialogContent>
        <Typography>
          Tem certeza que deseja encerrar a competição?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancelar</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Encerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default StopConfirmationDialog;